module.exports = __webpack_public_path__ + "assets/img/gold.6b724206.png";